import React, { useEffect, useState } from "react";
import {
    ConfirmationModal,
    CustomTable,
    DeleteButton,
    EditButton,
    EditForm,
    MessageBox,
    MotionDiv,
    useTitle,
} from "../../components";
import {
    useDeleteDesignationMutation,
    useEditDesignationMutation,
    useGetAllDesignationQuery
} from "../../store";
import { toastOptions } from "../../utils/error";
import { ToastContainer, toast } from "react-toastify";
import DeleteDesignation from "./DeleteDesignation";

const column = ["S.No", "Designation", "Created At", "Actions"];

const Designation = () => {
    useTitle("Designation");
    const [resultPerPage, setResultPerPage] = useState(5);
    const [page, setPage] = useState(1);
    const [modalShow, setModalShow] = useState(false);
    const [id, setId] = useState(null);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    const {
        isLoading,
        isError,
        error,
        data,
        refetch
    } = useGetAllDesignationQuery();

    const [
        editDesignation,
        {
            isLoading: isEditLoading,
            isSuccess: isEditSuccess,
            error: editError,
        },
    ] = useEditDesignationMutation();

    const [
        deleteDesignation,
        {
            isLoading: isDeleteLoading,
            isSuccess: isDeleteSuccess,
            isError: isDeleteError,
            error: deleteError,
        },
    ] = useDeleteDesignationMutation();

    const [info, setInfo] = useState({ designation: "" });

    const inputFieldProps = [
        {
            type: "text",
            col: 12,
            row: 8,
            props: {
                name: "designation",
                label: "Designation",
                required: true,
                placeHolder: `Enter Designation`,
            },
        },
    ];

    const deleteInit = (id) => {
        setId(id);
        setShowConfirmationModal(true);
    };

    const pageHandler = (p) => setPage(p);

    const handleResponse = (i) => {
        setId(data?.designation[i].id);
        setInfo({
            designation: data?.designation[i].designation  // Set the designation value
        });
        setModalShow(true);
    };

    const submitHandler = (e) => {
        e.preventDefault();
        editDesignation({ data: info, id });
    };

    useEffect(() => {
        if (isDeleteError) {
            toast.error(deleteError.data.error.message, toastOptions);
        }

        if (isDeleteSuccess) {
            toast.success("Designation Deleted Successfully!", toastOptions);
            setShowConfirmationModal(false);
            refetch();  // Refetch the table data after deletion
        }

        if (isEditSuccess) {
            // toast.success("Designation Updated Successfully!", toastOptions);
            setModalShow(false);
            refetch();
        }
    }, [isDeleteError, isDeleteSuccess, isEditSuccess, deleteError, refetch]);


    useEffect(() => {
        refetch();
    }, [isDeleteSuccess, isEditSuccess, refetch]);

    return (
        <MotionDiv>
            <CustomTable
                loading={isLoading}
                column={column}
                paging={false}
                rowNo={resultPerPage}
                rowProps={{ setResultPerPage }}
                pageProps={{ numOfPages: 1, curPage: 1 }}
                pageHandler={pageHandler}
                search={false}
                isCreateBtn={true}
                createBtnProps={{
                    createURL: "/admin/designation/add",
                    text: "Designation",
                }}
            >
                {isError ? (
                    <MessageBox variant="danger">
                        {error?.data?.error?.message}
                    </MessageBox>
                ) : (
                    data?.designation.map((query, i) => (
                        <tr key={query.id} className="odd">
                            <td className="text-center">{i + 1}</td>
                            <td>{query.designation}</td>
                            <td>{new Date(query.created_at).toLocaleString()}</td>
                            <td>
                                <EditButton onClick={() => handleResponse(i)} />
                                <DeleteButton onClick={() => deleteDesignation(query.id)} />
                            </td>
                        </tr>
                    ))
                )}
            </CustomTable>

            <EditForm
                title="Edit Designation"
                data={info}
                setData={setInfo}
                inputFieldProps={inputFieldProps}
                submitHandler={submitHandler}
                successMessage="Designation Updated Successfully!"
                show={modalShow}
                onHide={() => setModalShow(false)}
                reducerProps={{
                    loadingUpdate: isEditLoading,
                    success: isEditSuccess,
                    error: editError,
                }}
            />

            {/* <DeleteDesignation
                show={showConfirmationModal}
                onHide={() => setShowConfirmationModal(false)}
                id={id}
            /> */}

            <ToastContainer />
        </MotionDiv>
    );
};

export default Designation;
